/* Live Shopify catalog: progressive pages, a short per-market session cache, resolved Files images. */
(() => {
 'use strict';
 const api = window.CITYCAR, root = (api.root || '/').replace(/\/$/, '');
 const version = '8.7.42', imageWidths = new Map(), catalogs = new Map(), snapshots = new Map(), listeners = new Map();
 const theme = window.Shopify?.theme;
 const preview = new URLSearchParams(location.search).get('preview_theme_id') || (theme?.role && theme.role !== 'main' ? theme.id : '');
 const cachePrefix = 'citycar:catalog:';
 const context = [version, root, document.documentElement.lang, api.currency, window.Shopify?.country, theme?.id, preview].join('|');
 const seedCounts = new Map();
 const keyFor = scope => cachePrefix + context + '|' + scope;
 let images;
 const categoryQueries={'Накидки':'накидки','Органайзери':'органайзер','Подушки':'подушка','Аромапарфуми':'аромапарфум OR флакон','Килимки':'килимки','Чохли':'чохли'};
 api.categoryCatalogScope=category=>{const h=api.collectionHandle?.(category);return h&&api.nativeCollections?.available?.[h]?h:(categoryQueries[category]||category==='Аксесуари')?'category:'+category:'all';};
 function cached(scope) {
  if (window.Shopify?.designMode) return null;
  try {
   const entry = JSON.parse(sessionStorage.getItem(keyFor(scope)) || 'null');
   return entry && Date.now() - entry.time < 120000 && Array.isArray(entry.items) ? entry : null;
  } catch { return null; }
 }
 function remember(scope, items, source) {
  if (window.Shopify?.designMode) return;
  try {
   // Evict expired entries only; never clear unrelated store/session data.
   for (const key of Object.keys(sessionStorage)) if (key.startsWith(cachePrefix)) {
    try { if (Date.now() - JSON.parse(sessionStorage.getItem(key)).time >= 120000) sessionStorage.removeItem(key); } catch { sessionStorage.removeItem(key); }
   }
   sessionStorage.setItem(keyFor(scope), JSON.stringify({time:Date.now(), items, source}));
  } catch { /* Private browsing/storage limits must not block catalog access. */ }
 }
 function catalogURL(source, page, scope = 'all') {
  const query=scope.startsWith('category:')?(api.catalogCategoryQuery?.(scope.slice(9))||categoryQueries[scope.slice(9)]):'';
  const collectionPath = root + '/collections/' + encodeURIComponent(query?'all':scope);
  const path = source === 'section' ? (scope === 'all' ? root + '/' : collectionPath) : source === 'view' ? collectionPath : scope === 'all' ? root + '/products.json' : collectionPath + '/products.json';
  const url = new URL(query?(source==='products'?root+'/products.json':root+'/search'):path, location.origin);
  if(query&&source!=='products'){url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('options[unavailable_products]','show');}
  url.searchParams.set('page', String(page));
  if (source === 'section') url.searchParams.set('section_id', 'cc-catalog-data');
  if (source === 'view') url.searchParams.set('view', 'citycar-data');
  if (source === 'products') url.searchParams.set('limit', '250');
  if (source !== 'products') {
   url.searchParams.set('cc_catalog', version);
   if (/^\d+$/.test(String(preview))) url.searchParams.set('preview_theme_id', String(preview));
  }
  return url.href;
 }
 async function fetchPage(source, page, scope) {
  const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 6000);
  try {
   const response = await fetch(catalogURL(source, page, scope), {credentials:'same-origin', signal:controller.signal});
   if (!response.ok) throw Error('CITYCAR catalog request failed');
   let data;
   if (source === 'section') {
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const payload = doc.querySelector('script[data-citycar-catalog]');
    if (!payload) throw Error('CITYCAR catalog section missing');
    data = JSON.parse(payload.textContent);
   } else data = await response.json();
   if (!Array.isArray(data.products)) throw Error('CITYCAR catalog products missing');
   if (source !== 'products' && (data.citycar_catalog_version !== version || data.page !== page)) throw Error('CITYCAR catalog version mismatch');
   return data;
  } finally { clearTimeout(timer); }
 }
 function publish(scope, items, source, complete) {
  for (const p of items) if (p.citycar_image) {
   try { imageWidths.set(new URL(p.citycar_image, location.href).pathname, p.citycar_image_width || 960); } catch { p.citycar_image = null; }
  }
  const state = {scope, items, source, complete};
  snapshots.set(scope, state);
  for (const notify of listeners.get(scope) || []) notify(state);
  api.catalogStatus = {scope, source, complete, count:items.length, resolved:items.filter(p => p.citycar_image).length};
  document.dispatchEvent(new CustomEvent('citycar:catalog-progress', {detail:api.catalogStatus}));
  if (complete) {
   document.dispatchEvent(new CustomEvent('citycar:catalog-ready', {detail:api.catalogStatus}));
   const status = document.querySelector('[data-citycar-catalog-status]');
   if (status) status.textContent = source === 'products' ? 'Каталог використовує оригінальні фото Shopify: відповіді теми тимчасово недоступні.' : `Предметні фото: ${api.catalogStatus.resolved} із ${items.length} товарів.`;
  }
  return items;
 }
 async function themedCatalog(source, scope, first, prefetched = new Map()) {
  const pages = Number(first.pages);
  if (!Number.isInteger(pages) || pages < 0 || pages > 500) throw Error('CITYCAR catalog pagination invalid');
  const results = new Map([[1, first.products]]);
  let next = 2, contiguous = 1;
  publish(scope, first.products, source, pages <= 1);
  async function worker() {
   while (next <= pages) {
    const page = next++;
    let result;
    try {
     const pending = prefetched.get(page);
     if (pending) { const settled = await pending; if (settled.error) throw settled.error; result = settled.data; }
     else result = await fetchPage(source, page, scope);
    }
    catch { result = await fetchPage(source === 'section' ? 'view' : 'section', page, scope); }
    results.set(page, result.products);
    const before = contiguous;
    while (results.has(contiguous + 1)) contiguous++;
    if (contiguous > before) publish(scope, Array.from({length:contiguous}, (_,i) => results.get(i + 1)).flat(), source, contiguous === pages);
   }
  }
  // Only three concurrent requests, shared by every consumer on the page.
  const outcomes = await Promise.allSettled(Array.from({length:Math.min(3, Math.max(0, pages - 1))}, worker));
  if (outcomes.some(r => r.status === 'rejected')) throw Error('CITYCAR catalog page unavailable');
  return Array.from({length:Math.max(1,pages)}, (_,i) => results.get(i + 1)).flat();
 }
 async function originalCatalog(scope) {
  const all = [];
  for (let page = 1; page <= 100; page++) {
   const data = await fetchPage('products', page, scope);
   all.push(...data.products.map(p => ({...p,available:p.variants.some(v=>v.available),price:Math.round(Math.min(...p.variants.map(v=>Number(v.price)))*100),variants:p.variants.map(v=>({...v,price:Math.round(Number(v.price)*100),compare_at_price:Math.round(Number(v.compare_at_price||0)*100)}))})));
   const complete = data.products.length < 250;
   publish(scope, all.slice(), 'products', complete);
   if (complete) return all;
  }
  throw Error('CITYCAR catalog pagination limit');
 }
 async function loadCatalog(scope) {
  const stored = cached(scope);
  if (stored) return publish(scope, stored.items, stored.source, true);
  let source, first, prefetched = new Map();
  for (const candidate of ['section', 'view']) {
   try {
    const firstRequest = fetchPage(candidate, 1, scope);
    // Shopify includes the total in the HTML: start the next two feed pages
    // alongside page one, rather than imposing a second network round trip.
    prefetched = new Map();
    const anticipated = Math.ceil((seedCounts.get(scope) || 0) / 50);
    for (let page = 2; page <= Math.min(3, anticipated); page++) {
     prefetched.set(page, fetchPage(candidate, page, scope).then(data => ({data}), error => ({error})));
    }
    first = await firstRequest; source = candidate; break;
   } catch { /* Try the alternate endpoint once, not the whole catalog again. */ }
  }
  // Recheck an empty storefront search against the complete theme feed, retaining studio images.
  if (source && scope.startsWith('category:') && first.products.length === 0) {
   const items = await api.getCatalog('all');
   remember(scope, items, 'all-fallback');
   return publish(scope, items, 'all-fallback', true);
  }
  const items = source ? await themedCatalog(source, scope, first, prefetched) : await originalCatalog(scope);
  remember(scope, items, source || 'products');
  return items;
 }
 api.watchCatalog = (scope = 'all', callback) => {
  scope = scope || 'all';
  if (!listeners.has(scope)) listeners.set(scope, new Set());
  listeners.get(scope).add(callback);
  if (snapshots.has(scope)) callback(snapshots.get(scope));
  return () => listeners.get(scope)?.delete(callback);
 };
 api.getCatalog = (scope = 'all') => {
  scope = scope || 'all';
  if (!catalogs.has(scope)) catalogs.set(scope, loadCatalog(scope).catch(error => {catalogs.delete(scope); throw error;}));
  return catalogs.get(scope);
 };
 // A complete native collection is already included in Shopify's HTML.
 // Reuse it for filters and menu navigation instead of requesting it again.
 for (const box of document.querySelectorAll('[data-cc-paged-catalog]')) {
  const scope=box.dataset.catalogScope;
  if (!scope || scope==='search') continue;
  try {
   const data=JSON.parse(box.querySelector('[data-catalog-seed]')?.textContent||'null');
   if (data?.page===1 && Number.isInteger(data.total) && data.total>=0) seedCounts.set(scope,data.total);
   if (data?.page!==1 || !Number.isInteger(data.pages) || data.pages<0 || data.pages>1 || !Array.isArray(data.products)) continue;
   const items=publish(scope,data.products,'page',true);
   remember(scope,items,'page');catalogs.set(scope,Promise.resolve(items));
  } catch { /* An incomplete or malformed page still uses the live feed. */ }
 }
 Object.defineProperty(api, 'catalogPromise', {configurable:true, get:api.getCatalog});
 api.getImageMap = () => images || (images = api.getCatalog().then(items => Object.fromEntries(items.filter(p => p.citycar_image).map(p => [String(p.id), new URL(p.citycar_image, location.href).href]))).catch(() => { images = null; return {}; }));
 api.getProductImage = (p, map = {}) => {
  const embroidery = p.group === 'Вишивка' || /вишив/i.test(p.title || '');
  const parentPhoto = embroidery && (api.embroideryImages?.[String(p.parentProduct)] || api.embroideryImages?.[p.parentHandle]);
  return parentPhoto || api.generatedImages?.[String(p.id)] || api.generatedImages?.[p.handle] || p.citycar_image || (api.studioCovers && map[String(p.id)]) || p.images?.[0]?.src || (typeof p.images?.[0] === 'string' ? p.images[0] : '') || p.image?.src || (typeof p.image === 'string' ? p.image : '') || '';
 };
 api.imageWidth = input => input ? imageWidths.get(new URL(input, location.href).pathname) || 960 : 960;
 api.imageUrl = (input, width = 160) => {
  if (!input) return '';
  const url = new URL(input, location.href);
  if (url.pathname.includes('/assets/') && /\/citycar-8740-[^/]+(?:-thumb)?\.webp$/.test(url.pathname)) {
   url.pathname = url.pathname.replace(/(?:-thumb)?\.webp$/, width <= 400 ? '-thumb.webp' : '.webp');
   url.searchParams.delete('width');
   return url.href;
  }
  if (url.pathname.includes('/files/') || url.hostname === 'cdn.shopify.com') {
   const nativeWidth = imageWidths.get(url.pathname);
   url.searchParams.set('width', String(nativeWidth ? Math.min(width, nativeWidth) : width));
  }
  return url.href;
 };
})();
